var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "women_2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#161510"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EC9A1C"
    },
    cx: 72.5,
    cy: 57.721,
    rx: 30.016,
    ry: 31.728
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M109.373,115.395c-4.963-9.396-36.873-15.292-36.873-15.292s-31.912,5.896-36.875,15.292 C31.957,128.433,29.174,145,29.174,145H72.5h42.924C115.424,145,114.039,127.236,109.373,115.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.5,100.103c0,0,31.91,5.896,36.873,15.292c4.666,11.842,6.051,29.605,6.051,29.605H72.5 V100.103z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.812,
    y: 81.001,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.375,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 81.001,
    style: {
      fill: "#E4B692"
    },
    width: 8.688,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.813,94.475c1.563,4.485,7.869,7.057,12.5,7.057 c1.676,0,3.305-0.28,4.875-0.795V81.001H63.813V94.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.838,62.653c0-18.162-10.002-28.489-22.338-28.489S50.162,44.491,50.162,62.653 S60.164,95.539,72.5,95.539S94.838,80.815,94.838,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M92.234,75.245c-4.049-0.451-6.783-5.088-6.096-10.353c0.676-5.269,4.512-9.18,8.563-8.732 c4.047,0.448,6.777,5.083,6.094,10.352C100.115,71.782,96.285,75.689,92.234,75.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M44.098,66.513c-0.684-5.269,2.045-9.903,6.09-10.352c4.055-0.448,7.889,3.463,8.568,8.732 c0.684,5.265-2.053,9.901-6.1,10.353C48.607,75.689,44.775,71.782,44.098,66.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M94.838,62.653c0-18.162-10.002-28.489-22.338-28.489v61.375 C84.836,95.539,94.838,80.815,94.838,62.653z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EC9A1C"
    },
    cx: 72.5,
    cy: 28.475,
    r: 15.107
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9426,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M59.227,103.094 c0,0.012,0,0.023,0,0.034"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9426,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.0651,2.6035"
    },
    d: " M59.479,105.718c1.224,6.252,6.732,10.969,13.345,10.969c7.056,0,12.86-5.378,13.531-12.26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9426,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M86.42,103.128 c0-0.012,0-0.022,0-0.034"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92278F"
    },
    d: "M72.5,128.768c-15.166,0-28.816-2.991-38.367-7.766C31.16,132.732,28.889,145,28.889,145H72.5 h43.611c0,0-1.519-13.004-4.881-24.177C101.666,125.703,87.857,128.768,72.5,128.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92278F"
    },
    d: "M46.994,107.426v19.933h3.168v-21.187C49.084,106.573,48.023,106.991,46.994,107.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92278F"
    },
    d: "M100.9,108.74c-1.012-0.495-2.072-0.973-3.17-1.43v20.048h3.17V108.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC9A1C"
    },
    d: "M50.188,56.161c0,0,24.633,0.009,31-9.564c5.303,7.978,13.65,9.588,13.65,9.588l-0.533-16.502 l-14.994-8.775L51.426,35.96L50.188,56.161z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.812,
    y: 97.654,
    style: {
      fill: "#92278F"
    },
    width: 17.375,
    height: 4.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.242,
    y: 72.657,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.127,
    height: 2.128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.363,
    y: 72.657,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.127,
    height: 2.128
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.6263f73d4277e1c7036bfb942a0241ed.svg";
export { ForwardRef as ReactComponent };